const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "unlink-alt",
    "data-name": "Line Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon line-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M8,15h2m4-6h2",
    style: {
      fill: "none",
      stroke: "rgb(44, 169, 188)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M10,12a1,1,0,0,0-1-1H4a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M14,12a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H15a1,1,0,0,0-1,1",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.d8286a365f7e10860cddfac3e49838ac.svg";
export { ForwardRef as ReactComponent };